import { SearchTarget } from "../enums/SearchTarget";
import { CommonFunctions } from "../static/common-functions";
import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

export class DQOIItem extends BaseBus {
    constructor(data: DQOIItem = null) {
        super(data);
        if (CommonFunctions.hasValue(data)) {
            this.initialize(data);
            this.index = data.index;
            this.invoiceDueDate = DateFunctions.getDate(data.invoiceDueDate);
//            this.isNew = data.isNew;
//            this.dispatchAdded = data.dispatchAdded;
        }
        //this.searchTarget = data.searchTarget;
    }
    isConstruction: boolean;
    searchTarget: SearchTarget = SearchTarget.any;
    target: string = "";
    id: any;
    number: string;
    index: number = 0;
    isSearchable: boolean;
    customerId: any;
    locationId: any;
    dispatchId: any;
    quoteId: any;
    orderId: any;
    invoiceId: any;
    customerName: string;
    locationName: string;

    dispatchNumber: string;
    quoteNumber: string;
    orderNumber: string;
    invoiceNumber: string;
    woNumber: string;
    poNumber: string;
    dispatchStatusName: string;
    invoiceStatusName: string;
    quoteStatusName: string;
    orderStatusName: string;
    priorityName: string;
    color: number;
    dispatchStatusId: any;
    priorityId: any;
    dispatchAccountClassId: any;
    masterJobId: any;
    relatedJobTypeId: any;
    dispatchAdded: boolean = false;
    orderAdded: boolean = false;
    quoteAdded: boolean = false;
    invoiceAdded: boolean = false;
    contractAdded: boolean = false;
    jobAdded: boolean = false;

    isNew: boolean = false;

    jobId: any;
    jobNumber: string;
    contractNumber: string;
    contractStatus: string;
    jobStatus: string;
    isContract: boolean;
    isJob: boolean;
    isBidSheetAdmin:boolean;
    invoiceTotal: number;
    invoicePayments: number;
    invoiceCollNote: string;
    invoiceDueDate: Date;
    invoiceIsPastDue: boolean;

    linkedSalesOrderId: any;
    linkedSalesOrderNumber: string;

    linkedCPDispatchId: any;
    linkedCPDispatchNumber: string;

    contractId: any;
    orderCount: number;
    quoteCount: number;
    invoiceCount: number;

    //get contractId(): any {
    //    return this.contractId;
    //}
    get hasContractId(): boolean {
        return CommonFunctions.hasGuidValue(this.dispatchId) && CommonFunctions.hasGuidValue(this.masterJobId) && this.contractId === this.masterJobId;
    }
    get hasDispatchId(): boolean {
        return CommonFunctions.hasGuidValue(this.dispatchId);
    }
    get hasQuoteId(): boolean {
        return CommonFunctions.hasGuidValue(this.quoteId);
    }
    get hasOrderId(): boolean {
        return CommonFunctions.hasGuidValue(this.orderId);
    }
    get hasInvoiceId(): boolean {
        return CommonFunctions.hasGuidValue(this.invoiceId);
    }
    get hasJobId(): boolean {
        return CommonFunctions.hasGuidValue(this.jobId);
    }
    get hasDispatch(): boolean {
        return this.hasDispatchId || CommonFunctions.hasStringValue(this.dispatchNumber) || this.dispatchAdded;
    }
    get hasQuote(): boolean {
        return this.hasQuoteId || CommonFunctions.hasStringValue(this.quoteNumber) || this.quoteAdded;
    }
    get hasOrder(): boolean {
        return this.hasOrderId || CommonFunctions.hasStringValue(this.orderNumber) || this.orderAdded;
    }
    get hasInvoice(): boolean {
        return this.hasInvoiceId || CommonFunctions.hasStringValue(this.invoiceNumber) || this.invoiceAdded;
    }
    get hasContract(): boolean {
        return this.hasDispatchId || CommonFunctions.hasStringValue(this.dispatchNumber) || this.contractAdded;
    }
    get hasJob(): boolean {
        return this.hasJobId || CommonFunctions.hasStringValue(this.jobNumber) || this.jobAdded;
    }
    get hasCustomerId(): boolean {
        return CommonFunctions.hasValue(this.customerId);
    }
    get hasLocationId(): boolean {
        return CommonFunctions.hasValue(this.locationId);
    }
    get hasSalesOrder(): boolean {
        return CommonFunctions.hasGuidValue(this.linkedSalesOrderId);
    }
    get hasCPDispatch(): boolean {
        return CommonFunctions.hasGuidValue(this.linkedCPDispatchId);
    }
}